<template>
  <div class="img-upload">
    <a-upload
      name="file"
      listType="picture-card"
      :accept="accept"
      :multiple="isMultiple"
      :action="action"
      :headers="headers"
      :fileList="fileList"
      :beforeUpload="beforeUpload"
      :disabled="disabled"
      :isMultiple="isMultiple"
      @change="handleChange"
      @preview="handlePreview"
      :class="[!isMultiple ? 'imgupload' : '', !isMultiple && picUrl ? 'image-upload-single-over' : '']"
    >
      <div v-if="fileList.length < number">
        <div class="iconp">
          <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
          <div class="ant-upload-text">{{ text }}</div>
        </div>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel()">
      <img alt="preview Image" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
const uidGenerator = () => {
  return '-' + parseInt(Math.random() * 10000 + 1, 10)
}
const getFileName = path => {
  if (path.lastIndexOf('\\') >= 0) {
    const reg = new RegExp('\\\\', 'g')
    path = path.replace(reg, '/')
  }
  return path.substring(path.lastIndexOf('/') + 1)
}
export default {
  name: 'YzImageUpload',
  data() {
    return {
      uploadLoading: false,
      picUrl: false,
      fileList: [],
      previewImage: '',
      previewVisible: false,
      messageInstance: null
    }
  },
  props: {
    action: {
      type: String,
      required: false,
      default: `${process.env.VUE_APP_API_BASE_URL}/public/upload-file-qi-niu`
    },
    domains: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      required: false,
      default: ''
    },
    text: {
      type: String,
      required: false,
      default: '上传'
    },
    value: {
      type: [String, Array],
      default: () => '',
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isMultiple: {
      type: Boolean,
      required: false,
      default: false
    },
    headers: {
      type: Object,
      default: () => {
        return {}
      }
    },
    number: {
      type: Number,
      required: false,
      default: 0
    },
    maxSize: {
      type: Number,
      required: false,
      default: 5
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val instanceof Array) {
          this.initFileList(val.join(','))
        } else {
          this.initFileList(val)
        }
        if (!val || val.length === 0) {
          this.picUrl = false
        }
      },
      immediate: true
    }
  },
  methods: {
    initFileList(paths) {
      if (!paths || paths.length === 0) {
        this.fileList = []
        return
      }
      this.picUrl = true
      const fileList = []
      const arr = paths.split(',')
      for (let i = 0; i < arr.length; i++) {
        const url = arr[i]
        fileList.push({
          uid: uidGenerator(),
          name: getFileName(arr[i]),
          status: 'done',
          url: `${this.domains}/${url}`,
          _url: `${url}`,
          response: {
            code: '000000',
            data: { url: `${arr[i]}` }
          }
        })
      }
      this.fileList = fileList
    },
    beforeUpload(file, fileList) {
      const fileType = file.type
      const fileSize = file.size
      if (fileType.indexOf('image') < 0) {
        this.$message.warning({ content: '请选择图片!', key: 'errorInfoFlag' })
        fileList.splice(fileList.indexOf(file), 1)
        return false
      }
      if (fileSize > this.maxSize * 1024 * 1024) {
        this.$message.warning(`图片大小不超过${this.maxSize}M!`)
        fileList.splice(fileList.indexOf(file), 1)
        return false
      }
      return true
    },
    handleChange(info) {
      this.picUrl = false
      let fileList = info.fileList
      const fileType = info.file.type
      // 上传多个，截取最大为【number】条
      if (this.number > 0 && this.isMultiple) {
        fileList = fileList.slice(-this.number)
      }
      if (info.file.status === 'done') {
        if (info.file.response?.code === '000000') {
          this.picUrl = true
          fileList = fileList.map(file => {
            if (file.response) {
              file._url = file?.response?.data?.url
            }
            return file
          })
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败!`)

        fileList.forEach(file => {
          if (file.uid === info.file.uid) {
            file.response = file?.response?.message ?? '上传失败！'
          }
        })
      } else if (info.file.status === 'removed') {
        this.handleDelete(info.file)
      }

      // 过滤非图片
      if (!info.file.status && fileType.indexOf('image') < 0) {
        fileList = fileList.filter(f => f.uid !== info.file.uid)
      }

      this.fileList = fileList
      if (info.file.status === 'done' || info.file.status === 'removed') {
        this.handlePathChange()
      }
    },
    // 预览
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    handlePathChange() {
      const uploadFiles = this.fileList
      const resultFiles = []

      if (!this.isMultiple && uploadFiles.length > 0) {
        resultFiles.push(uploadFiles[uploadFiles.length - 1].response.data?.url)
      } else {
        for (let a = 0; a < uploadFiles.length; a++) {
          if (uploadFiles[a].status === 'done') {
            resultFiles.push(`${uploadFiles[a].response.data?.url}`)
          } else {
            return
          }
        }
      }
      this.$emit('change', resultFiles)
    },
    handleDelete(file) {
      // 删除
      this.$emit('delete', file)
    },
    handleCancel() {
      this.close()
      this.previewVisible = false
    },
    close() {}
  },
  model: {
    prop: 'value',
    event: 'change'
  }
}
</script>

<style lang="less" scoped>
/deep/ .imgupload .iconp {
  padding: 20px;
}

/deep/ .image-upload-single-over .ant-upload-select {
  display: none;
}
</style>
